import React from 'react';
import Webcam from "react-webcam";
import "./RockPaperScissors.css"

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import "./modal.css"

import { useState } from 'react';
import { Modal, Button, Form } from "react-bootstrap";


function RockPaperScissors() {
  function handleSubmitRock(e) {
    e.preventDefault();
    window.alert('Computer Plays Paper. Computer Wins!');
  }
  function handleSubmitScissors(e) {
    e.preventDefault();
    window.alert('Computer Plays Rock. Computer Wins!');
  }
  function handleSubmitPaper(e) {
    e.preventDefault();
    window.alert('Computer Plays Scissors. Computer Wins!');
  }

  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);

  return (
    <div className="App">

      <header className="App-header">

      <Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Rock Paper Scissors AI </strong> </div>
        <div className="content">
          {' '}
          <div>
             One of the most beautiful things about artificial intelligence is how it allows us to understand ourselves. Creating an artificial intelligence is almost like creating a self portrait, or silvering a mirror.<br />
        <br />
        As humans, we underestimate how predictable we truly are. We might think that we are capable of acting randomly, we might think that we are capable of out-thinking our opponent - but we are humbled when our opponent is one step ahead of us, or when our ‘random’ behavior is actually predictable.<br />
        <br />
        By analyzing deep patterns in player behavior, and learning from several different types of player strategies identified in humans, we have created one of the best rock-paper-scissors players to date.<br />
        <br />
        Head-to-head, it can beat all but the very best human rock paper scissors players in the world in a set of 100 games. It only takes a couple of turns for our machine to determine your player type and overall strategic tendencies. For our less experienced rock-paper-scissors players, this learning phase may be as short as 0 turns. The rest of your games are all but lost.
        <br />
        {/* <Button className="button" onClick={closeModal}> Let's Get Started!
        
         </Button> */}
        <br />
        <br /> </div>

        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>






        {/* <div class="container">
          <form onSubmit={handleSubmitRock}>
            <button class="button" type="submit">Rock</button>
          </form>
          <form onSubmit={handleSubmitPaper}>
            <button class="button" type="submit">Paper</button>
          </form>
          <form onSubmit={handleSubmitScissors}>
            <button class="button" type="submit">Scissors</button>
          </form>
        </div> */}
        <Popup trigger={<button className="button"> Rock </button>} modal>
          <span class = "modal"> AI Plays Paper. AI Wins! </span>
        </Popup>
        <Popup trigger={<button className="button"> Paper </button>} modal>
          <span class = "modal"> AI Plays Scissors. AI Wins! </span>
        </Popup>
        <Popup trigger={<button className="button"> Scissors </button>} modal>
          <span class = "modal"> AI Plays Rock. AI Wins! </span>
        </Popup>
      </header>

    </div>
  );
}

export default RockPaperScissors;
